import Swiper from "swiper";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  Autoplay,
} from "swiper/core";
import { register } from "@shopify/theme-sections";

register("announcement_bar", {
  onLoad() {
    SwiperCore.use([Navigation, Pagination, EffectFade, Autoplay]);
    var announcementSwiper = new SwiperCore(".swiper-container-announcement", {
      effect: "fade",
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
    });
  },
});
